import ServiceBase from './ServiceBase';

export default class IncomingMessageService extends ServiceBase {
    async getIncomingMessages(filters) {
        var results = await this.requestJson({
            url: `api/incomingmessage/incoming`,
            method: "GET",
            data: filters
        });

        return results;
    }

    async getIncomingMessage(id) {
        var result = await this.requestJson({
            url: `api/incomingmessage/incoming/${id}`,
            method: "GET"
        });

        return result;
    }

    async updateIncomingMessage(msg) {
        var result = await this.requestJson({
            url: `api/incomingmessage/incoming/${msg.id}`,
            method: "PUT",
            data: msg
        });

        return result;
    }

    async getIncomingMessageAttachment(messageId, attachmentId) {
        let callResponse = undefined;

        let webapi = `api/incomingmessage/incoming/${messageId}/file/${attachmentId}`;
        const token = this.getToken();
        callResponse = fetch(webapi,
                {
                    method: 'GET',
                    headers: {
                        responseType: 'blob',
                        authorization: token
                    }
                })
            .then(response => response.blob())
            .then(blob => {
                let objUrl = URL.createObjectURL(blob);
                return { result: true, model: objUrl };
            });

        return callResponse;
    }
}